enum LEVELS_PATHS {
	MY_LEVEL = "/levels/my",
	MY_REFERRAL_SYSTEM = "/referral/my",
	SET_PROMO_CODE = "/referral/my/set-code",
	MY_TRANSACTIONS = "/account/events/my",
	CHECK_REFERRAL_CODE = "/referral/check",
}

export default LEVELS_PATHS;
